import React, { FC, PropsWithChildren, useContext } from 'react'
import { LocaleLink } from '../../common/intl/LocaleLink'
import { LocalPath } from '../../common/intl/LocalPath'
import classNames from 'classnames'
import { LocaleContext } from '../../common/intl/LocaleContext'

interface Props extends PropsWithChildren {
  to: LocalPath | string
  title?: string | null
  className?: string
  active?: boolean
  partiallyActive?: boolean
  optionalActivePrefix?: string
}

export const HeaderMenuItem: FC<Props> = ({
  title,
  to,
  partiallyActive,
  optionalActivePrefix,
  active,
  className,
  children,
}) => {
  const { pathWithoutLocale } = useContext(LocaleContext)
  const optionallyActive = optionalActivePrefix ? pathWithoutLocale.startsWith(optionalActivePrefix) : false

  return (
    <LocaleLink
      className={classNames('py-2 hover:text-white no-underline', className, {
        'text-white': active || optionallyActive,
      })}
      activeClassName="text-white"
      partiallyActive={partiallyActive}
      to={to}
      title={title || undefined}
    >
      {children}
    </LocaleLink>
  )
}
